import { useQuery } from 'react-query';
import { JobRequisitionReasonService } from '../../../services/v1/applicant_tracking/JobRequisitionReasonService';

export const useJobRequisitionReasons = (includeReasonId?: number) => {
  return useQuery({
    queryKey: ['job_requisition_reasons'],
    queryFn: async () =>
      await JobRequisitionReasonService.list(includeReasonId),
  });
};
